import { mediaData } from '@/mocks/homepage';

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">深度解读</h2>
          <p className="text-sm text-foreground-500 mt-2">专业视角 · 深度剖析娱乐圈大小事</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaData.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-2xl overflow-hidden group cursor-pointer">
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    const parent = target.parentElement;
                    if (parent) parent.classList.add('hidden');
                  }}
                />
                <div className="absolute inset-0 bg-foreground-950/20 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-background-50 transition-colors">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-foreground-950/70 rounded text-xs text-background-50 font-medium whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-1.5">
                  <i className="ri-eye-line mr-1"></i>{item.views} 次观看
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}